module.exports = "/wwwroot/img/news_page.png?ver=e53d1c3f";